"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BaseAuthInterceptor = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BaseAuthInterceptor = function BaseAuthInterceptor(tokenProvider) {
  _classCallCheck(this, BaseAuthInterceptor);

  Object.defineProperty(this, '_tokenProvider', {
    get: function get() {
      return tokenProvider;
    }
  });
};

exports.BaseAuthInterceptor = BaseAuthInterceptor;


//////////////////
// WEBPACK FOOTER
// ./node_modules/lbs-pi-platform-access/es/core/BaseAuthInterceptor.js
// module id = 251
// module chunks = 0